const PropTypes = require("prop-types");
// @ vendors
const React = require("react");
const { connect } = require("react-redux");
const PureRenderMixin = require("react-addons-pure-render-mixin");
// @ commons
const { FormattedText, formatText } = require("core/i18n").i18n;
const {
    ACC_NUMBER_LENGTH,
    ACC_NUMBER_REGEX,
    BENEFICIARY_BANK_OPTION_BIC,
    BENEFICIARY_BANK_OPTION_NAME
} = require("constants/index");
// @ components
const BeneficiaryNewBankDetails = require("components/transfersSteps/transferSteps/transferStep1/beneficiaryNewBankDetails/beneficiaryNewBankDetails");
const { RadioButton } = require("commonsComponents/radioButton");
const { RadioButtonGroup } = require("commonsComponents/radioButtonGroup");
const { InputSafe } = require("commonsComponents/inputSafe");
const MaskedIban = require("components/maskedIban/maskedIban");
const MaskedBic = require("components/maskedBic/maskedBic");
const { OKInput } = require("commonsComponents/OKInput");
const { IbanModal } = require("components/ibanModal/ibanModal");
const { LoadingSection } = require("commonsComponents/loadingSection");
//@actions
const bankEntityActions = require("actions/bankEntity");
// @helpers
const { isSepa } = require("utilities/transfersHelper");

class BeneficiaryNewAccounts extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            accountNumber: props.immBeneficiaryNew.get("accountNumber")
        };

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(
            this
        );
        this.handleAccountNumberChange = this.handleAccountNumberChange.bind(
            this
        );
        this.handleAccountNumberBlur = this.handleAccountNumberBlur.bind(this);
        this.handleModalToggle = this.handleModalToggle.bind(this);
        this.handleBeneficiaryBankOption = this.handleBeneficiaryBankOption.bind(this);
    }

    componentDidMount() {
        const {
            getBankNameFromIban,
            immBankEntity,
            getBankNameFromBic,
            immBeneficiaryNew,
            getProductOffers
        } = this.props;

        if (immBeneficiaryNew.get("ibanIsValid")) {
            getBankNameFromIban(
                immBeneficiaryNew.get("iban"),
                immBankEntity.get("bankName")
            );
            !__CONTACT_CENTER__ && getProductOffers();
        } else if (immBeneficiaryNew.get("bicIsValid")) {
            getBankNameFromBic(immBeneficiaryNew.get("bic"));
        }
    }

    componentWillReceiveProps(nextProps) {
        const {
            getBankNameFromIban,
            immBankEntity,
            getBankNameFromBic,
        } = this.props;
        if (
            this.state.accountNumber !==
            nextProps.immBeneficiaryNew.get("accountNumber")
        ) {
            this.setState({
                accountNumber: nextProps.immBeneficiaryNew.get("accountNumber")
            });
        }

        if (
            nextProps.immBeneficiaryNew.get("ibanIsValid") &&
            nextProps.immBeneficiaryNew.get("iban") !==
                this.props.immBeneficiaryNew.get("iban")
        ) {
            getBankNameFromIban(
                nextProps.immBeneficiaryNew.get("iban"),
                immBankEntity.get("bankName")
            );
        } else if (
            nextProps.immBeneficiaryNew.get("bicIsValid") &&
            nextProps.immBeneficiaryNew.get("bic") !==
                this.props.immBeneficiaryNew.get("bic")
        ) {
            getBankNameFromBic(nextProps.immBeneficiaryNew.get("bic"));
        }
    }

    buildBankEntity() {
        const { immBeneficiaryNew, immBankEntity } = this.props;
        let bankEntitySection;

        if (
            immBeneficiaryNew.get("ibanIsValid") ||
            immBeneficiaryNew.get("bicIsValid")
        ) {
            const bankEntityLabel = formatText(
                "transferSummary-bankEntityTitle"
            );
            let bankEntityBody;
            if (immBankEntity.get("isLoading")) {
                bankEntityBody = <LoadingSection />;
            } else {
                const bankName = immBankEntity.get("bankName") || "-";
                bankEntityBody = (
                    <OKInput
                        label={bankEntityLabel}
                        value={bankName}
                        disabled
                    />
                );
            }
            bankEntitySection = (
                <div className="transfer-first-step__form-section">
                    {bankEntityBody}
                </div>
            );
        }

        return bankEntitySection;
    }

    buildBankSection() {
        const { immBeneficiaryNew, actions, isEditingScheduled } = this.props;
        let content;

        if (
            immBeneficiaryNew.get("bankOption") === BENEFICIARY_BANK_OPTION_BIC
        ) {
            const labelBic = formatText("transferSummary-step1BeneficiaryBic");

            const bicRequiredAlertVisible =
                immBeneficiaryNew.get("bicIsDirty") &&
                immBeneficiaryNew.get("bic") === "";
            const bicWrongFormatAlertVisible =
                immBeneficiaryNew.get("bicIsDirty") &&
                !immBeneficiaryNew.get("bicIsValid");
            let bicErrorMsg = formatText("transferSummary-step1BicIsInvalid");

            if (bicRequiredAlertVisible) {
                bicErrorMsg = formatText("transferSummary-requiredMessage", [
                    labelBic
                ]);
            }

            content = (
                <div className="transfer-first-step__form-section">
                    <MaskedBic
                        bic={immBeneficiaryNew.get("bic")}
                        label={labelBic}
                        id="inp_TransferStep1_BeneficiaryBic"
                        callback={actions.setBeneficiaryBic}
                        errorState={
                            bicRequiredAlertVisible ||
                            bicWrongFormatAlertVisible
                        }
                        errorMessage={bicErrorMsg}
                        disabled={isEditingScheduled}
                    />
                </div>
            );
        } else {
            content = (
                <BeneficiaryNewBankDetails
                    immBeneficiaryNew={immBeneficiaryNew}
                    actions={actions}
                    isEditingScheduled={isEditingScheduled}
                />
            );
        }

        return content;
    }

    errorMessage = (iban, ibanRequiredAlertVisible, labelIban, countryCode) => {
        if (ibanRequiredAlertVisible) {
            return formatText("transferSummary-requiredMessage", [labelIban]);
        } else if (
            iban &&
            countryCode &&
            countryCode.toUpperCase() == "ES" &&
            iban.length == 20 &&
            iban.match(/^[\d]{2}/)
        ) {
            return formatText("transferSummary-step1CCIsInvalid");
        }
        return formatText("transferSummary-step1IbanIsInvalid");
    };

    onHandleNewIban = (iban, valid) => {
        const { actions, handleBeneficiary } = this.props;
        
        actions.setBeneficiaryIban(iban, valid);
        
        if (valid) handleBeneficiary(iban);
    };
    
    handleBeneficiaryBankOption = (option) => {
        const { actions, resetBankName } = this.props;
        resetBankName();
        actions.handleBeneficiaryBankOption(option)
    }
    buildIbanSection() {
        const { immBeneficiaryNew, isEditingScheduled } = this.props;
        const countryCode = immBeneficiaryNew.get("country");
        const iban = immBeneficiaryNew.get("iban");
        const labelIban = formatText("transferSummary-step1BeneficiaryIban");
        const ibanIsDirty = immBeneficiaryNew.get("ibanIsDirty");
        const ibanRequiredAlertVisible = ibanIsDirty && iban === "";
        const ibanWrongFormatAlertVisible =
            ibanIsDirty && !immBeneficiaryNew.get("ibanIsValid");

        return (
            <div className="transfer-first-step__form-section">
                <MaskedIban
                    id="inp_TransferStep1_BeneficiaryIban"
                    label={labelIban}
                    iban={iban}
                    callback={this.onHandleNewIban}
                    onClickInfo={this.handleModalToggle}
                    errorState={
                        ibanRequiredAlertVisible || ibanWrongFormatAlertVisible
                    }
                    errorMessage={this.errorMessage(
                        iban,
                        ibanRequiredAlertVisible,
                        labelIban,
                        countryCode
                    )}
                    disabled={isEditingScheduled}
                    countryCode={countryCode}
                />
            </div>
        );
    }

    buildOutsideSepaSection() {
        const { immBeneficiaryNew, actions, isEditingScheduled } = this.props;

        const radioButtonsSection = this.buildRadioButtons();
        const bankSection = this.buildBankSection();

        const labelAccountNumber = formatText(
            "transferSummary-step1BeneficiaryAccountNumber"
        );

        const accountNumberRequiredAlertVisible =
            immBeneficiaryNew.get("accountNumberIsDirty") &&
            immBeneficiaryNew.get("accountNumber") === "";
        const accountNumberFormatAlertVisible =
            immBeneficiaryNew.get("accountNumberIsDirty") &&
            !immBeneficiaryNew.get("accountNumberIsValid");
        let accountNumberErrorMsg = formatText(
            "transferSummary-step1AccountNumberIsInvalid"
        );

        if (accountNumberRequiredAlertVisible) {
            accountNumberErrorMsg = formatText(
                "transferSummary-requiredMessage",
                [labelAccountNumber]
            );
        }

        return (
            <div className="beneficiary-new-accounts__outside-sepa">
                <div className="transfer-first-step__form-section">
                    <InputSafe
                        name="inp_accountNumber"
                        type="text"
                        autoComplete="off"
                        label={labelAccountNumber}
                        value={this.state.accountNumber}
                        onChange={this.handleAccountNumberChange}
                        onBlur={this.handleAccountNumberBlur}
                        maxLength={ACC_NUMBER_LENGTH}
                        errorState={
                            accountNumberRequiredAlertVisible ||
                            accountNumberFormatAlertVisible
                        }
                        errorMessage={accountNumberErrorMsg}
                        disabled={isEditingScheduled}
                    />
                </div>
                <div className="transfer-first-step__form-section">
                    <label
                        id="lbl_TransferStep1_BeneficiaryBankOption"
                        className="transfer-first-step__field-label"
                    >
                        <FormattedText value="transferSummary-step1BeneficiaryBank" />
                    </label>
                    <RadioButtonGroup
                        name="bank-option"
                        idPrefix="banks-option-radio"
                        selectedValue={immBeneficiaryNew.get("bankOption")}
                        onChange={this.handleBeneficiaryBankOption}
                    >
                        {radioButtonsSection}
                    </RadioButtonGroup>
                </div>
                {bankSection}
            </div>
        );
    }

    buildRadioButtons() {
        const { isEditingScheduled } = this.props;

        const options = [
            BENEFICIARY_BANK_OPTION_BIC,
            BENEFICIARY_BANK_OPTION_NAME
        ];
        return options.map((id, index) => {
            let label = formatText(
                `transferSummary-step1BeneficiaryBankOption${id}`
            );
            return (
                <RadioButton
                    key={index}
                    label={label}
                    value={id}
                    disabled={isEditingScheduled}
                />
            );
        });
    }

    handleAccountNumberBlur(evt) {
        const { handleBeneficiary } = this.props;
        const accountNumber = evt.target.value.toUpperCase();
        const isValid = ACC_NUMBER_REGEX.test(accountNumber);

        if (isValid) handleBeneficiary(accountNumber);

        this.setState(
            {
                accountNumber: accountNumber
            },
            () => {
                this.props.actions.setBeneficiaryAccountNumber(
                    accountNumber,
                    isValid
                );
            }
        );
    }

    handleAccountNumberChange(evt) {
        const accountNumber = evt.target.value.replace(
            /[^A-Z\d]/gi,
            ""
        ); /* remove non numbers or letters */
        this.setState({
            accountNumber: accountNumber
        });
    }

    handleModalToggle() {
        const { actions } = this.props;
        actions.toggleIbanModal();
    }

    render() {
        const { immBeneficiaryNew } = this.props;

        const insideSepa = isSepa(
            immBeneficiaryNew.get("country"),
            immBeneficiaryNew.get("currency")
        );
        const accountsSection = insideSepa
            ? this.buildIbanSection()
            : this.buildOutsideSepaSection();
        const ibanModal = <IbanModal onRequestClose={this.handleModalToggle} />;
        const bankEntitySection = this.buildBankEntity();

        return (
            <div className="beneficiary-new-accounts">
                {ibanModal}
                {accountsSection}
                {bankEntitySection}
            </div>
        );
    }
}

BeneficiaryNewAccounts.propTypes = {
    actions: PropTypes.object,
    getBankNameFromIban: PropTypes.func.isRequired,
    getBankNameFromBic: PropTypes.func.isRequired,
    getProductOffers: PropTypes.func.isRequired,
    immBankEntity: PropTypes,
    immBeneficiaryNew: PropTypes.object,
    isEditingScheduled: PropTypes.bool,
    handleBeneficiary: PropTypes.func.isRequired,
    resetBankName: PropTypes.func
    
};

module.exports = connect(null, {
    getBankNameFromIban: bankEntityActions.getBankNameFromIban,
    getBankNameFromBic: bankEntityActions.getBankNameFromBic
})(BeneficiaryNewAccounts);
